import { render } from "./UserAccounts.vue?vue&type=template&id=355e951f&scoped=true"
import script from "./UserAccounts.vue?vue&type=script&lang=js"
export * from "./UserAccounts.vue?vue&type=script&lang=js"

import "./UserAccounts.vue?vue&type=style&index=0&id=355e951f&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355e951f"]])

export default __exports__